import type { ClientOptions, RpcClient } from "@redotech/rpc/client";
import { createRpcClient } from "@redotech/rpc/client";
import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { rpcDefinition } from "./definition";

export function createRedoMerchantRpcClient(
  options: ClientOptions<typeof rpcDefinition>,
): RedoMerchantRpcClient {
  return createRpcClient(rpcDefinition, options);
}

export type RedoMerchantRpcClient = RpcClient<
  InferRpcDefinition<typeof rpcDefinition>
>;
